module.exports = __webpack_public_path__ + "img/header-engagementRings@2x.3ac23b2.webp";